import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const BADGE = {
  pendiente:  { bg:'rgba(231,111,81,0.15)',  color:'#c0392b', label:'Pendiente' },
  revision:   { bg:'rgba(230,176,55,0.15)',  color:'#b7770d', label:'En revisión' },
  respondido: { bg:'rgba(159,190,106,0.2)',  color:'#2c5e2e', label:'Respondido' },
};

const TIPO_LABEL = { peticion:'Petición', queja:'Queja', reclamo:'Reclamo', sugerencia:'Sugerencia' };

export default function PqrsAdmin() {
  const [lista, setLista] = useState([]);
  const [filtro, setFiltro] = useState('todos');

  const cargar = () => api.get('/pqrs').then(r => setLista(r.data)).catch(() => {});
  useEffect(() => { cargar(); }, []);

  const cambiarEstado = async (id, estado) => {
    await api.put(`/pqrs/${id}/estado`, { estado });
    cargar();
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar este PQR?')) return;
    await api.delete(`/pqrs/${id}`);
    toast.success('PQR eliminado');
    cargar();
  };

  const filtrados = filtro === 'todos' ? lista : lista.filter(p => p.estado === filtro);

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24, flexWrap:'wrap', gap:12 }}>
        <div>
          <h1 style={{ fontFamily:'var(--font-display)', fontSize:28, color:'var(--forest)', margin:0 }}>PQRs</h1>
          <p style={{ color:'var(--ink-faint)', fontSize:13, margin:'4px 0 0' }}>Peticiones, Quejas, Reclamos y Sugerencias</p>
        </div>
        <div style={{ display:'flex', gap:8 }}>
          {['todos','pendiente','revision','respondido'].map(f => (
            <button key={f} onClick={() => setFiltro(f)}
              style={{ padding:'6px 14px', borderRadius:20, border:'1.5px solid rgba(28,58,30,0.15)', fontSize:12, fontWeight:700, cursor:'pointer',
                background: filtro===f ? '#1C3A1E' : '#fff', color: filtro===f ? '#9FBE6A' : 'var(--forest)' }}>
              {f === 'todos' ? 'Todos' : BADGE[f]?.label}
            </button>
          ))}
        </div>
      </div>

      {filtrados.length === 0 ? (
        <div className="card"><div className="card-body" style={{ textAlign:'center', padding:48, color:'var(--ink-faint)' }}>No hay PQRs {filtro !== 'todos' ? 'con este estado' : ''}</div></div>
      ) : filtrados.map(p => (
        <div key={p.id} className="card" style={{ marginBottom:16 }}>
          <div className="card-body">
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', flexWrap:'wrap', gap:12 }}>
              <div style={{ flex:1 }}>
                <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:8, flexWrap:'wrap' }}>
                  <span style={{ background:'rgba(28,58,30,0.08)', color:'var(--forest)', padding:'3px 10px', borderRadius:20, fontSize:12, fontWeight:700 }}>
                    {TIPO_LABEL[p.tipo] || p.tipo}
                  </span>
                  <span style={{ background: BADGE[p.estado]?.bg, color: BADGE[p.estado]?.color, padding:'3px 10px', borderRadius:20, fontSize:12, fontWeight:700 }}>
                    {BADGE[p.estado]?.label || p.estado}
                  </span>
                  <span style={{ fontSize:12, color:'var(--ink-faint)' }}>
                    {new Date(p.created_at).toLocaleDateString('es-CO', { day:'2-digit', month:'short', year:'numeric' })}
                  </span>
                </div>
                <div style={{ fontWeight:700, fontSize:15, color:'var(--forest)', marginBottom:4 }}>{p.nombre}</div>
                <div style={{ fontSize:13, color:'var(--ink-light)', marginBottom:8 }}>
                  {p.email} {p.telefono ? '· ' + p.telefono : ''}
                </div>
                <p style={{ fontSize:14, color:'var(--ink-mid)', lineHeight:1.7, margin:0 }}>{p.mensaje}</p>
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:8, flexShrink:0 }}>
                <select value={p.estado}
                  onChange={e => cambiarEstado(p.id, e.target.value)}
                  style={{ padding:'6px 12px', borderRadius:8, border:'1.5px solid rgba(28,58,30,0.15)', fontSize:13, fontWeight:600, cursor:'pointer', color:'var(--forest)' }}>
                  <option value="pendiente">Pendiente</option>
                  <option value="revision">En revisión</option>
                  <option value="respondido">Respondido</option>
                </select>
                <button onClick={() => eliminar(p.id)}
                  style={{ padding:'6px 12px', borderRadius:8, border:'none', background:'rgba(231,111,81,0.1)', color:'#c0392b', fontWeight:700, fontSize:13, cursor:'pointer' }}>
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
